// removed by extract-text-webpack-plugin
module.exports = {"Content":"_3pLYCt_XGv-qW86lAaB4Ex"};


//////////////////
// WEBPACK FOOTER
// ./src/hoc/Layout/Layout.css
// module id = 105
// module chunks = 0